export const getLivingSpace = (
  livingSpace: number | null,
  additionalSpace?: number | null,
) => {
  if (livingSpace === null) return "";
  if (additionalSpace) return `${livingSpace} + ${additionalSpace} m²`;
  return `${livingSpace} m²`;
};

export function getLivingSpaceRange(min: number | null, max: number | null) {
  if (min && max) {
    const [formattedMin, formattedMax] = [min,max].map(x => x.toLocaleString("sv-SE"));
    if (min === max) return `${formattedMin} m²`
    return `${formattedMin} - ${formattedMax} m²`
  }
  if (min) {
    return `Från ${min.toLocaleString("sv-SE")} m²`
  }
  if (max) {
    return `Upp till ${max.toLocaleString("sv-SE")} m²`
  }

  return "";
}
